import type { IReportTable } from '../../common/Visualization/types';
import type { AnalyticDateFilter } from '~/presentation/ui';
import type { DataSeries } from '@shopify/polaris-viz';
import type { IRMetricKey } from '../../common/type';

import { buildSeriesMap, getAllDatesSorted, buildDataSeries } from './chartData';
import { TIME_KEYS } from '~/modules/report-analytic';
import { deepCopy } from '~/utils';

export const getBarChartData = ({
  data,
  metricKey,
  dimensions,
  dateFilter,
  templateLabelById,
  hasFilterByCampaign,
}: {
  data: IReportTable;
  metricKey: IRMetricKey;
  dimensions: string[];
  dateFilter: {
    currentDates: AnalyticDateFilter;
    previousDates: AnalyticDateFilter;
  };
  templateLabelById: Record<string, string>;
  hasFilterByCampaign: boolean;
}): { seriesData: DataSeries[]; seriesKey: Set<string>; isFirstTimeDimension: boolean } => {
  const chartKeys = deepCopy(dimensions).slice(0, 2);
  const isFirstTimeDimension = TIME_KEYS.has(chartKeys[0]);

  const { seriesMap, keysSet, seriesKey } = buildSeriesMap({
    data,
    metricKey,
    chartKeys,
    templateLabelById,
  });

  const allKeys = getAllDatesSorted(keysSet, isFirstTimeDimension);

  const showComparison = dimensions.length < 2 && !hasFilterByCampaign;
  const seriesData = buildDataSeries({
    seriesMap,
    allKeys,
    showComparison,
    dateFilter,
  });

  return {
    seriesData,
    seriesKey,
    isFirstTimeDimension,
  };
};
